angular.module('bmsApp.sm')
	.factory('SMEnquiryRejectedReasonSvc', [
		'CRUDSvc',
		function (CRUDSvc) {

			return {
				options: function (params) {
					return CRUDSvc.get('api/sm/enquiryRejectedReason/options', params);
				}
			}

		}
	]);
